"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initExpoLiveWidget = exports.LiveWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _firebase = require("../firebase");

var _database = require("react-firebase-hooks/database");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 5px 10px;\n  background: red;\n  color: white;\n  font-size: 15px;\n  margin-left: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LiveWidget = _styledComponents.default.div(_templateObject());

exports.LiveWidget = LiveWidget;

function App() {
  var _useObjectVal = (0, _database.useObjectVal)(_firebase.db.ref('isLive')),
      _useObjectVal2 = _slicedToArray(_useObjectVal, 3),
      isLive = _useObjectVal2[0],
      loading = _useObjectVal2[1],
      error = _useObjectVal2[2];

  return /*#__PURE__*/_react.default.createElement("div", null, isLive ? /*#__PURE__*/_react.default.createElement(LiveWidget, null, "Live") : null);
}

var mountApp = function mountApp(id) {
  var mountNode = document.getElementById(id);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(App, null), mountNode);
};

var initExpoLiveWidget = function initExpoLiveWidget(bus) {
  var onEvent = function onEvent(_ref) {
    var type = _ref.type,
        payload = _ref.payload;

    if (type === 'mount' && payload.name === 'expo-live-widget') {
      mountApp(payload.id);
    }
  };

  bus.subscribe(onEvent);
};

exports.initExpoLiveWidget = initExpoLiveWidget;